"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComputeWarnings = exports.filterWarningByWarningsFilter = exports.computeWarningNumbers = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const toolkit_1 = require("@reduxjs/toolkit");
const moment_1 = __importDefault(require("moment"));
const computeWarningNumbers = (shifts, timeOffs, calendarFilters, calendar) => {
    if (!(0, util_1.isValue)(calendar))
        return {};
    const reloadPeriod = util_1.calendarUtil.getReloadPeriod(calendar);
    const events = [...(shifts ?? []), ...(timeOffs ?? [])];
    const eventsInPeriod = events.filter((evt) => evt?.period?.start &&
        (0, moment_1.default)(evt?.period?.start).isBetween(reloadPeriod?.start, reloadPeriod?.end, 'minute', '()'));
    const filteredEventsInPeriod = util_1.calendarUtil
        .getFilteredEvents(eventsInPeriod, calendarFilters, false)
        .filter((s) => s.warnings && s.warnings.length > 0);
    const countWarningsByType = { all: 0 };
    const countWarningsByDate = {};
    filteredEventsInPeriod.forEach((s) => {
        s.warnings?.forEach((w) => {
            const _name = w.name ?? 'error';
            if (!countWarningsByType[_name])
                countWarningsByType[_name] = 0;
            countWarningsByType[_name] += 1;
            countWarningsByType.all += 1;
            countWarningsByDate[(0, moment_1.default)(s.period?.start).format('YYYY-MM-DD')] = {
                ...countWarningsByDate[(0, moment_1.default)(s.period?.start).format('YYYY-MM-DD')],
                [_name]: +1,
            };
        });
    });
    return {
        countWarnings: countWarningsByType.all,
        countWarningsByType,
        countWarningsByDate: (0, exports.filterWarningByWarningsFilter)(countWarningsByDate, calendarFilters),
    };
};
exports.computeWarningNumbers = computeWarningNumbers;
const filterWarningByWarningsFilter = (countWarningsByDate, calendarFilters) => {
    const hiddenWarnings = calendarFilters.find((filter) => Array.isArray(filter?.hideWarnings) && filter?.hideWarnings.length);
    const filteredWarnings = {};
    if (!countWarningsByDate)
        return filteredWarnings;
    for (const date of Object.keys(countWarningsByDate)) {
        let tempArray = {};
        for (const type of Object.keys(countWarningsByDate[date])) {
            if (!hiddenWarnings?.hideWarnings?.includes(type)) {
                tempArray = {
                    ...tempArray,
                    [type]: countWarningsByDate[date][type],
                };
            }
        }
        filteredWarnings[date] = tempArray;
    }
    return filteredWarnings;
};
exports.filterWarningByWarningsFilter = filterWarningByWarningsFilter;
const selectShifts = (state) => state.shifts;
const selectTimeOffs = (state) => state.timeOffs;
const selectCalendar = (state) => state.calendar;
const selectCalendarFilters = (state) => state.calendarFilters;
const selectShiftsAndTimeOffs = (0, toolkit_1.createSelector)([selectShifts, selectTimeOffs, selectCalendar, selectCalendarFilters], (shifts, timeOffs, calendar, calendarFilters) => (0, exports.computeWarningNumbers)(shifts, timeOffs, calendarFilters, calendar));
const useComputeWarnings = () => {
    return (0, store_1.useRootSelector)(selectShiftsAndTimeOffs);
};
exports.useComputeWarnings = useComputeWarnings;
